import {createSelector} from "reselect";

const inventory = (state) => state.inventory;

const inventoriesData = createSelector(inventory, (data) => data?.inventoriesData || {});

export const getInventoriesList = createSelector(inventoriesData, (data) => {
  const inventories = data?.results || [];
  if (inventories?.length > 0) {
    return inventories.map((inventory) => ({
      ...inventory,
      profile: inventory?.profile?.label,
      profileObject: inventory?.profile,
    }));
  } else {
    return [];
  }
});

export const getTotalCount = createSelector(inventoriesData, (data) => data?.count || 0);

export const getInventoryPaginationUrls = createSelector(inventoriesData, (data) => ({
  prevUrl: data?.previous || "",
  nextUrl: data?.next || "",
}));

export const getSimDropdownData = createSelector(
  inventory,
  (inventories) => inventories.simDropdownData
);

export const getSystemProfile = createSelector(
  inventory,
  (inventories) => inventories.systemProfile
);

export const getEditInventoryData = createSelector(
  inventory,
  (inventories) => inventories.editInventoryInfo
);
